import React, { useState } from "react"
import { Box, Button, IconButton, Tooltip } from "@material-ui/core"
import { useSnackbar } from "../SnackbarProvider"
import { useAuth } from "../../services"
import { useDownloadExportJob } from "../../data"
import { RowBox } from "../Boxes"
import { Icon } from "../Icon"
import { LoadingSpinner } from "../LoadingSpinner"
import { useOffline } from "../Offline/useOffline"

const DownloadExportJobButton = ({ job, variant = "outlined", color = "default" }) => {
  const {
    location,
    settings: { organisation },
  } = useAuth()
  const { offline } = useOffline()
  const [exporting, setExporting] = useState(false)
  const snackbar = useSnackbar()
  const downloadExportJob = useDownloadExportJob()

  const handleExport = async () => {
    setExporting(true)
    const result = await downloadExportJob({ job, location, organisation })
    if (result.error) {
      snackbar.showMessage({ message: result.error, color: "secondary", icon: <Icon name="warning" /> })
    }
    setExporting(false)
  }

  if (variant === "icon") {
    return (
      <Tooltip title="Export PDF" placement="top">
        <IconButton onClick={handleExport} disabled={offline}>
          {!exporting && <Icon name="pdf" />}
          {exporting && <LoadingSpinner size="24px" delay={false} />}
        </IconButton>
      </Tooltip>
    )
  }

  return (
    <Button variant={variant} onClick={handleExport} color={color} disabled={offline}>
      {!exporting && (
        <RowBox>
          <Icon name="document" />
          <Box ml={1}>Export PDF</Box>
        </RowBox>
      )}
      {exporting && <LoadingSpinner size="24px" delay={false} />}
    </Button>
  )
}

export { DownloadExportJobButton }
